import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { CompletedView } from "./view";
import { useDispatch, useSelector } from "react-redux";
import { quoteAll, quoteAllClearData, } from "../../../store/generateQuote/actions";
import { executeReports, executeReportsClearData, } from "../../../store/reports/actions";
import LocalStorageService from "../../../services/localStorage";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formattedDate, formattedDateWithTime } from "../../../utils/date";
import { downloadReports } from "../../../fnx/reportsDowload";
import { getExportConfig, getReportTitle, } from "./completedDTO";
import showToast from "../../../services/toast";
import { Branches } from "../../../store/branches/actions";
import { useProjectsByCustomerId } from "../../../fnx/projectsByCustomerId";
import { showErrorToast } from "../../../fnx/showError";
import { useTranslation } from "react-i18next";
import { getCatalogStatusQuote, getCatalogStatusQuoteClearData, } from "../../../store/catalog/actions";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import { getQuoteList } from "../../../utils/normalizeQuoteResponse";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var FIRST_FEE_REPORT_ID = "b7147547-893a-4161-805d-0810dfe3dd04";
var TRAVEL_ASSISTANCE_REPORT_ID = "5d27b544-cd22-49d1-afff-61666d1b14bd";
var HEALTH_PREFERENTIAL_REPORT_ID = "5015ccf0-faeb-4693-83a3-64b5e986929b";
var UPCOMING_CANCELLATIONS_REPORT_ID = "6270c849-d3cd-489b-bf31-eba6e92e43dc";
var BALANCE_AGING_REPORT_ID = "42b61ae0-ab91-4987-b6d6-a4d51ed442f1";
var resolveReportTypeFromPath = function () {
    var pathname = window.location.pathname;
    if (pathname.includes("/report/first-fee"))
        return "first-fee";
    if (pathname.includes("/report/travel-assistance"))
        return "travel-assistance";
    if (pathname.includes("/report/health-preferential"))
        return "health-preferential";
    if (pathname.includes("/report/upcoming-cancellations"))
        return "upcoming-cancellations";
    if (pathname.includes("/report/balance-aging"))
        return "balance-aging";
    return "sales";
};
var isExecuteReportType = function (type) {
    return type === "first-fee" ||
        type === "travel-assistance" ||
        type === "health-preferential" ||
        type === "upcoming-cancellations" ||
        type === "balance-aging";
};
var getExecuteReportId = function (type) {
    if (type === "travel-assistance")
        return TRAVEL_ASSISTANCE_REPORT_ID;
    if (type === "health-preferential")
        return HEALTH_PREFERENTIAL_REPORT_ID;
    if (type === "upcoming-cancellations")
        return UPCOMING_CANCELLATIONS_REPORT_ID;
    if (type === "balance-aging")
        return BALANCE_AGING_REPORT_ID;
    return FIRST_FEE_REPORT_ID;
};
var toApiDate = function (isoDate) { return isoDate.split("T")[0]; };
var defaultApiStartDate = function () {
    var d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    return d.toISOString().split("T")[0];
};
var defaultApiEndDate = function () { return new Date().toISOString().split("T")[0]; };
export var Completed = function () {
    var _a;
    var id = useParams().id;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var location = useLocation();
    var titleFromState = (_a = location.state) === null || _a === void 0 ? void 0 : _a.title;
    var reportType = resolveReportTypeFromPath();
    var _b = getExportConfig(reportType), fields = _b.fields, labelFields = _b.labelFields;
    var isInitialMount = React.useRef(true);
    // responseAllQuote puede traer datos residuales de otra pantalla (p. ej. el
    // dashboard de reportes); se ignora el valor presente al montar y solo se
    // pinta la grilla con la respuesta de la petición propia de esta pantalla.
    var isInitialQuoteResponse = React.useRef(true);
    var _c = React.useState(true), enable = _c[0], setEnable = _c[1];
    var _d = React.useState(1), page = _d[0], setPage = _d[1];
    var _e = React.useState(5000), limit = _e[0], setLimit = _e[1];
    var _f = useState([]), rows = _f[0], setRows = _f[1];
    var _g = React.useState(""), startDate = _g[0], setStartDate = _g[1];
    var _h = React.useState(""), endDate = _h[0], setEndDate = _h[1];
    var _j = React.useState(false), isLoadin = _j[0], setIsLoading = _j[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var ids = useState("41b2c419-832e-4867-989a-f4f32155bf5e,56044e38-892b-4c31-86c1-25a7e35438cc")[0];
    var _k = useState(""), nameSearch = _k[0], setNameSearch = _k[1];
    var _l = useState(""), description = _l[0], setDescription = _l[1];
    var _m = useState(reportType !== "sales" ? getReportTitle(reportType) : ""), title = _m[0], setTitle = _m[1];
    var _o = useState([]), branchesOptions = _o[0], setBranchesOptions = _o[1];
    var _p = useState([]), insuranceOptions = _p[0], setInsuranceOptions = _p[1];
    var _q = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _q[0], setSeeToast = _q[1];
    var _r = React.useState(""), sponsorId = _r[0], setSponsorId = _r[1];
    var _s = useState(false), trigger = _s[0], setTrigger = _s[1];
    var responseInsurance = useProjectsByCustomerId(clientId, trigger, "", "", sponsorId).responseInsurance;
    var _t = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _t.responseAllQuote, errorAllQuote = _t.errorAllQuote, loadingAllQuote = _t.loadingAllQuote;
    var _u = useSelector(function (state) {
        var _a;
        return ({
            responseBranches: (_a = state.Branches.responseBranches) === null || _a === void 0 ? void 0 : _a.data,
            errorBranches: state.Branches.errorBranches,
            loadingBranches: state.Branches.loadingBranches,
        });
    }), responseBranches = _u.responseBranches, errorBranches = _u.errorBranches, loadingBranches = _u.loadingBranches;
    var _v = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogStatusQuote: (_a = state.Catalog.responseGetCatalogStatusQuote) === null || _a === void 0 ? void 0 : _a.data,
            errorGetCatalogStatusQuote: state.Catalog.errorGetCatalogStatusQuote,
            loadingGetCatalogStatusQuote: state.Catalog.loadingGetCatalogStatusQuote,
        });
    }), responseGetCatalogStatusQuote = _v.responseGetCatalogStatusQuote, errorGetCatalogStatusQuote = _v.errorGetCatalogStatusQuote, loadingGetCatalogStatusQuote = _v.loadingGetCatalogStatusQuote;
    var _w = useSelector(function (state) {
        var _a;
        return ({
            responseExecuteReports: (_a = state.Reports.responseExecuteReports) === null || _a === void 0 ? void 0 : _a.data,
            errorExecuteReports: state.Reports.errorExecuteReports,
            loadingExecuteReports: state.Reports.loadingExecuteReports,
        });
    }), responseExecuteReports = _w.responseExecuteReports, errorExecuteReports = _w.errorExecuteReports, loadingExecuteReports = _w.loadingExecuteReports;
    var loadExecuteReportData = function (startDate, endDate) {
        if (startDate === void 0) { startDate = ""; }
        if (endDate === void 0) { endDate = ""; }
        dispatch(executeReports({
            id: getExecuteReportId(reportType),
            fkClientId: clientId,
            params: {
                FechaInicio: startDate ? toApiDate(startDate) : defaultApiStartDate(),
                FechaFin: endDate ? toApiDate(endDate) : defaultApiEndDate(),
            },
            page: 1,
            pageSize: limit,
        }));
    };
    useEffect(function () {
        if (reportType !== "sales")
            return;
        if (!responseGetCatalogStatusQuote)
            return;
        var foundItem = responseGetCatalogStatusQuote.find(function (item) { return item.id === id; });
        if ((foundItem === null || foundItem === void 0 ? void 0 : foundItem.description) === "Emitida") {
            setTitle("Reporte de ventas");
            setDescription('"Si desea aplicar un filtro al resultado de ventas completadas, seleccione el filtro deseado que se muestra a continuación."');
        }
        else if ((foundItem === null || foundItem === void 0 ? void 0 : foundItem.description) === "Cancelada") {
            setTitle("Reporte de ventas canceladas");
            setDescription("Si desea aplicar un filtro al resultado de ventas canceladas, seleccione el filtro deseado que se muestra a continuación.");
        }
        else {
            setTitle("Reporte de ventas y cancelaciones");
            setDescription("Si desea aplicar un filtro al resultado de ventas completadas y canceladas, seleccione el filtro deseado que se muestra a continuación.");
        }
    }, [responseGetCatalogStatusQuote, id]);
    useEffect(function () {
        setDescription("");
        if (!responseBranches) {
            dispatch(Branches({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
            }));
        }
        if (isExecuteReportType(reportType)) {
            loadExecuteReportData();
        }
        else {
            getQuoteAll();
            if (!responseGetCatalogStatusQuote && reportType === "sales") {
                dispatch(getCatalogStatusQuote({ enable: enable, page: page, limit: limit }));
            }
        }
    }, []);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setSeeToast, t);
        }
    }, [errorAllQuote]);
    useEffect(function () {
        if (errorGetCatalogStatusQuote) {
            showErrorToast(errorGetCatalogStatusQuote, setSeeToast, t);
        }
    }, [errorGetCatalogStatusQuote]);
    useEffect(function () {
        if (errorBranches) {
            showErrorToast(errorBranches, setSeeToast, t);
        }
    }, [errorBranches]);
    useEffect(function () {
        if (errorExecuteReports && isExecuteReportType(reportType)) {
            showErrorToast(errorExecuteReports, setSeeToast, t);
        }
    }, [errorExecuteReports]);
    useEffect(function () {
        if (isInitialQuoteResponse.current) {
            isInitialQuoteResponse.current = false;
            return;
        }
        var quoteList = getQuoteList(responseAllQuote);
        if (quoteList.length > 0 && !isExecuteReportType(reportType)) {
            setDataReportStorybook(quoteList);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        if (Array.isArray(responseExecuteReports) &&
            isExecuteReportType(reportType)) {
            setDataReportStorybook(responseExecuteReports);
        }
    }, [responseExecuteReports]);
    useEffect(function () {
        if (Array.isArray(responseInsurance)) {
            setInsuranceOptionsStorybook(responseInsurance);
        }
    }, [responseInsurance]);
    useEffect(function () {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        if (nameSearch && !isExecuteReportType(reportType)) {
            getQuoteAll();
        }
        else if (!nameSearch) {
            onCloseSearch();
        }
    }, [nameSearch]);
    useEffect(function () {
        if (Array.isArray(responseBranches)) {
            setBranchesOptionsStorybook(responseBranches);
        }
    }, [responseBranches]);
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    var onCloseSearch = function () {
        setNameSearch("");
        if (isExecuteReportType(reportType)) {
            loadExecuteReportData(startDate, endDate);
            return;
        }
        getQuoteAll();
    };
    var getQuoteAll = function () {
        dispatch(quoteAll({
            clientId: clientId,
            enable: enable,
            statuses: id !== null && id !== void 0 ? id : ids,
            page: page,
            limit: limit,
            search: nameSearch,
        }));
    };
    var setBranchesOptionsStorybook = function (responseBranches) {
        var dataBranches = [];
        responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.map(function (item) {
            if (item.id && item.name) {
                dataBranches.push({
                    id: item.id,
                    name: item.name,
                    active: false,
                });
            }
        });
        setBranchesOptions(dataBranches);
    };
    var setInsuranceOptionsStorybook = function (responseProject) {
        var dataInsurance = [];
        responseProject === null || responseProject === void 0 ? void 0 : responseProject.map(function (item) {
            if (item.id && item.description) {
                dataInsurance.push({
                    id: item.id,
                    name: item.description,
                    active: false,
                });
            }
        });
        setInsuranceOptions(dataInsurance);
    };
    var mapRowData = function (items) {
        switch (reportType) {
            case "balance-aging":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        certificado: item === null || item === void 0 ? void 0 : item["Certificado"],
                        primerNombre: item === null || item === void 0 ? void 0 : item["Nombre"],
                        segundoNombre: "",
                        primerApellido: item === null || item === void 0 ? void 0 : item["Primer Apellido"],
                        segundoApellido: item === null || item === void 0 ? void 0 : item["Segundo Apellido"],
                        cedula: item === null || item === void 0 ? void 0 : item["Cedula"],
                        cuenta: item === null || item === void 0 ? void 0 : item["Cuenta"],
                        tipoCuenta: item === null || item === void 0 ? void 0 : item["Tipo de Cuenta"],
                        fechaEfectiva: (item === null || item === void 0 ? void 0 : item["Fecha Efectiva"])
                            ? formattedDate(item === null || item === void 0 ? void 0 : item["Fecha Efectiva"])
                            : "",
                        prima: (item === null || item === void 0 ? void 0 : item["Prima"]) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item["Prima"]) : "",
                        formaPago: item === null || item === void 0 ? void 0 : item["Forma Pago"],
                        cuotasPendientes: item === null || item === void 0 ? void 0 : item["Cuotas Pendientes"],
                        descripcionProducto: item === null || item === void 0 ? void 0 : item["Descripcion Producto"],
                        ultimoPeriodoFacturado: item === null || item === void 0 ? void 0 : item["Ultimo Periodo Facturado"],
                        rango1_30: item === null || item === void 0 ? void 0 : item["1-30"],
                        rango31_60: item === null || item === void 0 ? void 0 : item["31-60"],
                        rango61_90: item === null || item === void 0 ? void 0 : item["61-90"],
                        polizaProtegida: item === null || item === void 0 ? void 0 : item["Poliza Protegida"],
                    });
                });
            case "upcoming-cancellations":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        certificado: item === null || item === void 0 ? void 0 : item["Certificado"],
                        nombreProducto: item === null || item === void 0 ? void 0 : item["Nombre Producto"],
                        fechaEmision: (item === null || item === void 0 ? void 0 : item["Fecha Emision"])
                            ? formattedDate(item === null || item === void 0 ? void 0 : item["Fecha Emision"])
                            : "",
                        nombre: item === null || item === void 0 ? void 0 : item["Nombre"],
                        apellido: item === null || item === void 0 ? void 0 : item["Apellido"],
                        cedula: item === null || item === void 0 ? void 0 : item["Cedula Cliente"],
                        nombreProductoApap: item === null || item === void 0 ? void 0 : item["Nombre Producto APAP"],
                        noProductoApap: item === null || item === void 0 ? void 0 : item["No Producto APAP"],
                        prima: (item === null || item === void 0 ? void 0 : item["Prima"]) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item["Prima"]) : "",
                        modalidadPago: item === null || item === void 0 ? void 0 : item["Modalidad Pago"],
                        estado: item === null || item === void 0 ? void 0 : item["Desc Estatus"],
                        nombreEmpleado: item === null || item === void 0 ? void 0 : item["Nombre Empleado"],
                        posicionEmpleado: item === null || item === void 0 ? void 0 : item["Posicion Empleado"],
                        usuario: item === null || item === void 0 ? void 0 : item["Usuario"],
                        sucursal: item === null || item === void 0 ? void 0 : item["Sucursal"],
                    });
                });
            case "health-preferential":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        noCertificado: item === null || item === void 0 ? void 0 : item.polizaid,
                        nombreProductoBanca: item === null || item === void 0 ? void 0 : item.descripcion,
                        fechaEmision: (item === null || item === void 0 ? void 0 : item.fechaefectiva)
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.fechaefectiva)
                            : "",
                        fechaActualizacion: (item === null || item === void 0 ? void 0 : item.fechaaccionusuario)
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.fechaaccionusuario)
                            : "",
                        tipoActualizacion: item === null || item === void 0 ? void 0 : item.tipoactualizacion,
                        tipoAsegurado: item === null || item === void 0 ? void 0 : item.tipoasegurado,
                        nombre: item === null || item === void 0 ? void 0 : item.nombre,
                        apellido: item === null || item === void 0 ? void 0 : item.apellido,
                        cedula: item === null || item === void 0 ? void 0 : item.nodocumento,
                        nombreProductoApap: item === null || item === void 0 ? void 0 : item.descripcion,
                        noProductoPrima: item === null || item === void 0 ? void 0 : item.nocuenta,
                        prima: (item === null || item === void 0 ? void 0 : item.premium) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item.premium) : "",
                        estado: item === null || item === void 0 ? void 0 : item.estado,
                        nombreEmpleado: item === null || item === void 0 ? void 0 : item.nombreempleado,
                        usuario: item === null || item === void 0 ? void 0 : item.usuario,
                        sucursal: item === null || item === void 0 ? void 0 : item.sucursal,
                        fechaCancelacion: (item === null || item === void 0 ? void 0 : item.fechacancelacion) && (item === null || item === void 0 ? void 0 : item.fechacancelacion) !== ""
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.fechacancelacion)
                            : "",
                        motivoCancelacion: item === null || item === void 0 ? void 0 : item.motivocancelacion,
                    });
                });
            case "travel-assistance":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        on: item === null || item === void 0 ? void 0 : item.polizaid,
                        fecha: (item === null || item === void 0 ? void 0 : item.fechaefectiva) ? formattedDate(item === null || item === void 0 ? void 0 : item.fechaefectiva) : "",
                        noVoucher: item === null || item === void 0 ? void 0 : item.voucher,
                        nombre: item === null || item === void 0 ? void 0 : item.nombrea,
                        apellido: item === null || item === void 0 ? void 0 : item.apellidoa,
                        fechaNacimiento: (item === null || item === void 0 ? void 0 : item.fechanacimiento)
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.fechanacimiento)
                            : "",
                        telefono: (item === null || item === void 0 ? void 0 : item.telefonocasa) || (item === null || item === void 0 ? void 0 : item.telefonomovil) || (item === null || item === void 0 ? void 0 : item.telefonooficina),
                        correo: item === null || item === void 0 ? void 0 : item.correoelectronico,
                        cedula: item === null || item === void 0 ? void 0 : item.secuencia,
                        noPasajeros: item === null || item === void 0 ? void 0 : item.nopasajeros,
                        fechaSalida: (item === null || item === void 0 ? void 0 : item.startdate) ? formattedDate(item === null || item === void 0 ? void 0 : item.startdate) : "",
                        fechaRegreso: (item === null || item === void 0 ? void 0 : item.enddate) ? formattedDate(item === null || item === void 0 ? void 0 : item.enddate) : "",
                        status: item === null || item === void 0 ? void 0 : item.cnfestatuspolizaid,
                        noReferencia: item === null || item === void 0 ? void 0 : item.voucher,
                        tipoCuenta: item === null || item === void 0 ? void 0 : item.descriptionshort,
                        noCuenta: item === null || item === void 0 ? void 0 : item.numberaccount,
                        montoPrimaUSD: (item === null || item === void 0 ? void 0 : item.premium) != null ? "USD ".concat(item === null || item === void 0 ? void 0 : item.premium) : "",
                        montoPrimaRD: (item === null || item === void 0 ? void 0 : item.primiunpesos) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item.primiunpesos) : "",
                        tasa: item === null || item === void 0 ? void 0 : item.exchangerate,
                    });
                });
            case "first-fee":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        poliza: item === null || item === void 0 ? void 0 : item.PolizaId,
                        nombre: item === null || item === void 0 ? void 0 : item.NombreA,
                        primerApellido: item === null || item === void 0 ? void 0 : item.ApellidoA,
                        segundoApellido: item === null || item === void 0 ? void 0 : item.ApellidoB,
                        secuencia: item === null || item === void 0 ? void 0 : item.Secuencia,
                        cuenta: item === null || item === void 0 ? void 0 : item.NumeroCuenta,
                        tipoCuenta: item === null || item === void 0 ? void 0 : item.TipoCuenta,
                        fechaEfectiva: (item === null || item === void 0 ? void 0 : item.FechaEfectiva)
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.FechaEfectiva)
                            : "",
                        monto: (item === null || item === void 0 ? void 0 : item.Monto) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item.Monto) : "",
                        producto: item === null || item === void 0 ? void 0 : item.Producto,
                        codigoTransaccion: item === null || item === void 0 ? void 0 : item.CodigoTransaccion,
                    });
                });
            default: // "sales"
                return items.map(function (item) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
                    return ({
                        id: item === null || item === void 0 ? void 0 : item.id,
                        certificate: (item === null || item === void 0 ? void 0 : item.policyId) ? (_a = item === null || item === void 0 ? void 0 : item.policyId) === null || _a === void 0 ? void 0 : _a.code : item.code,
                        product: (_b = item === null || item === void 0 ? void 0 : item.productId) === null || _b === void 0 ? void 0 : _b.description,
                        plan: (_c = item === null || item === void 0 ? void 0 : item.planId) === null || _c === void 0 ? void 0 : _c.name,
                        creationDate: (item === null || item === void 0 ? void 0 : item.policyId)
                            ? formattedDate((_d = item === null || item === void 0 ? void 0 : item.policyId) === null || _d === void 0 ? void 0 : _d.effectiveFrom)
                            : formattedDate(item === null || item === void 0 ? void 0 : item.creationDate),
                        names: "".concat(item === null || item === void 0 ? void 0 : item.firstNameA, " ").concat(item === null || item === void 0 ? void 0 : item.firstNameB),
                        lastNames: "".concat(item === null || item === void 0 ? void 0 : item.lastNameA, " ").concat(item === null || item === void 0 ? void 0 : item.lastNameB),
                        identificationNumber: item === null || item === void 0 ? void 0 : item.numberId,
                        paymentType: (_e = item === null || item === void 0 ? void 0 : item.customerAccount) === null || _e === void 0 ? void 0 : _e.accountType.description,
                        accountNumber: (_f = item === null || item === void 0 ? void 0 : item.customerAccount) === null || _f === void 0 ? void 0 : _f.accountNumber,
                        prime: "RD$ ".concat((_g = item === null || item === void 0 ? void 0 : item.customerAccount) === null || _g === void 0 ? void 0 : _g.amount),
                        paymentMode: (_h = item === null || item === void 0 ? void 0 : item.catalogPaymentMode) === null || _h === void 0 ? void 0 : _h.description,
                        status: (_j = item === null || item === void 0 ? void 0 : item.catalogStatusQuote) === null || _j === void 0 ? void 0 : _j.description,
                        employeePosition: (_k = item === null || item === void 0 ? void 0 : item.user) === null || _k === void 0 ? void 0 : _k.employeePosition,
                        user: (_l = item === null || item === void 0 ? void 0 : item.user) === null || _l === void 0 ? void 0 : _l.employeeCode,
                        userName: (_m = item === null || item === void 0 ? void 0 : item.user) === null || _m === void 0 ? void 0 : _m.fullName,
                        branch: (_o = item === null || item === void 0 ? void 0 : item.branchData) === null || _o === void 0 ? void 0 : _o.name,
                        cancellationDate: ((_p = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _p === void 0 ? void 0 : _p.createdAt) &&
                            formattedDate((_q = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _q === void 0 ? void 0 : _q.createdAt),
                        reasonCancellation: (_r = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _r === void 0 ? void 0 : _r.description,
                        insuranceCarrier: (_s = item === null || item === void 0 ? void 0 : item.sponsor) === null || _s === void 0 ? void 0 : _s.name,
                    });
                });
        }
    };
    var setDataReportStorybook = function (data) {
        var dataR = mapRowData(data);
        setRows(dataR);
        if (isExecuteReportType(reportType)) {
            dispatch(executeReportsClearData());
        }
        else {
            dispatch(quoteAllClearData());
        }
    };
    var onClickDownload = function (item) {
        setIsLoading(true);
        downloadReports(item, clientId, enable, page, limit, id ? id : ids, startDate, endDate, fields, labelFields, title, title)
            .then(function () {
            setSeeToast({
                show: true,
                message: t("salesReport.downloadFile"),
                type: typeAlert.success,
            });
        })
            .catch(function (error) {
            console.error("Error al descargar el archivo:", error);
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var filterStatus = function (item) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var newStartDate = formattedDateWithTime((_a = item === null || item === void 0 ? void 0 : item.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) === "undefined" ||
            formattedDateWithTime((_b = item === null || item === void 0 ? void 0 : item.dateRange) === null || _b === void 0 ? void 0 : _b.startDate) === "null" ||
            formattedDateWithTime((_c = item === null || item === void 0 ? void 0 : item.dateRange) === null || _c === void 0 ? void 0 : _c.startDate) === "NA"
            ? ""
            : formattedDateWithTime((_d = item === null || item === void 0 ? void 0 : item.dateRange) === null || _d === void 0 ? void 0 : _d.startDate);
        var newEndDate = formattedDateWithTime((_e = item === null || item === void 0 ? void 0 : item.dateRange) === null || _e === void 0 ? void 0 : _e.endDate) === "undefined" ||
            formattedDateWithTime((_f = item === null || item === void 0 ? void 0 : item.dateRange) === null || _f === void 0 ? void 0 : _f.endDate) === "null" ||
            formattedDateWithTime((_g = item === null || item === void 0 ? void 0 : item.dateRange) === null || _g === void 0 ? void 0 : _g.endDate) === "NA"
            ? ""
            : formattedDateWithTime((_h = item === null || item === void 0 ? void 0 : item.dateRange) === null || _h === void 0 ? void 0 : _h.endDate);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
        if (isExecuteReportType(reportType)) {
            loadExecuteReportData(newStartDate, newEndDate);
            return;
        }
        var idBranch = item === null || item === void 0 ? void 0 : item.branch.map(function (item) { return item.id; }).join(",");
        var idInsurance = item === null || item === void 0 ? void 0 : item.insurance.map(function (item) { return item.id; }).join(",");
        dispatch(quoteAll({
            clientId: clientId,
            enable: enable,
            statuses: id !== null && id !== void 0 ? id : ids,
            creationDateStart: newStartDate,
            creationDateEnd: newEndDate,
            branches: idBranch,
            projectIds: idInsurance,
            page: page,
            limit: limit,
        }));
    };
    var onClickBack = function () {
        if (reportType === "sales") {
            dispatch(getCatalogStatusQuoteClearData());
        }
        navigate("/reportsPage");
    };
    var isLoadingData = isExecuteReportType(reportType)
        ? loadingExecuteReports
        : loadingAllQuote || loadingGetCatalogStatusQuote;
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: isLoadingData || isLoadin || loadingBranches, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: isLoadin
                    ? "Descargando archivo"
                    : isExecuteReportType(reportType)
                        ? "Cargando ".concat(getReportTitle(reportType), ".")
                        : "Cargando Pólizas." }), _jsx(CompletedView, { reportType: reportType, title: title, searchFilter: searchFilter, onCloseSearch: onCloseSearch, branchOptions: branchesOptions, rows: rows, filterStatus: filterStatus, id: id, downloadFile: onClickDownload, insuranceOptions: insuranceOptions, onClickBack: onClickBack, description: description })] }));
};
